import { AnyIfEmpty } from 'react-redux';
import {
    GET_VENDOR_VISIT_FAILURE,
    GET_VENDOR_VISIT_LOCATION_FAILURE,
    GET_VENDOR_VISIT_LOCATION_REQUEST,
    GET_VENDOR_VISIT_LOCATION_SUCCESS,
    GET_VENDOR_VISIT_REQUEST,
    GET_VENDOR_VISIT_SUCCESS,
} from '../constants/vendorVisit.constants';

const initialState = {
    loading: false,
    data: [],
    errorMsg: '',
};

const vendorVisitReducer = (state = initialState, action: { type: string; payload: AnyIfEmpty<object> }) => {
    switch (action.type) {
        case GET_VENDOR_VISIT_REQUEST:
            return {
                loading: true,
                data: [],
                errorMsg: '',
            };
        case GET_VENDOR_VISIT_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                errorMsg: '',
            };

        case GET_VENDOR_VISIT_FAILURE:
            return {
                loading: false,
                data: [],
                errorMsg: action.payload,
            };

        case GET_VENDOR_VISIT_LOCATION_REQUEST:
            return {
                loading: true,
                data: [],
                errorMsg: '',
            };

        case GET_VENDOR_VISIT_LOCATION_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                errorMsg: '',
            };

        case GET_VENDOR_VISIT_LOCATION_FAILURE:
            return {
                loading: false,
                data: [],
                errorMsg: action.payload,
            };
        default:
            return state;
    }
};

export default vendorVisitReducer;
